import axios from 'axios'

export default {
  state: {
    favoriteList: []
  },
  mutations: {
    SET_FAVORITE_LIST(state, data) {
      state.favoriteList = data
    }
  },
  actions: {
    REMOVE_FROM_FAVORITES({ commit, dispatch, rootState }, advertId) {
      const sessionId = rootState.token
      return axios({
        url: `/api/user/RemoveFromFavorites/${sessionId}/${advertId}`,
        method: 'post'
      }).then(response => {
        if (response.data.success) {
          dispatch('GET_FAVORITE_LIST')
        }
        return response.data
      })
    },
    ADD_TO_FAVORITES({ commit, dispatch, rootState }, advertId) {
      const sessionId = rootState.token
      return axios({
        url: `/api/user/AddToFavorites/${sessionId}/${advertId}`,
        method: 'post'
      }).then(response => {
        if (response.data.success) {
          dispatch('GET_FAVORITE_LIST')
        }
        return response.data
      })
    },
    GET_FAVORITE_LIST({ commit, rootState }) {
      const sessionId = rootState.token
      return axios({
        url: `/api/Advert/GetFavorites/Ru/${sessionId}`,
        method: 'get'
      }).then(response => {
        commit('SET_FAVORITE_LIST', response.data.favorites)
      })
    }
  },
  getters: {
    isFavorite: state => advertId => {
      if (advertId && state.favoriteList.length) {
        let isFavorite = false
        state.favoriteList.map(advert => {
          if (advert.id === advertId.toString()) {
            isFavorite = true
          }
        })
        return isFavorite
      }
      return false
    }
  }
}
